import { useQuery } from 'react-query';

import { DataRoom, Guid } from '../../models';
import { useApi } from '../../context';
import { AxiosUtils } from '../../utils';
import { CerebroApiEndpoints } from '../../utils/api';
import { QueryKeys } from '.';

export function useDataRoomQuery(guid: Guid | undefined) {
	const api = useApi();

	return useQuery(
		QueryKeys.DataRoom.Root(guid),
		() => AxiosUtils.getResponseData<DataRoom>(api.get(CerebroApiEndpoints.DataRooms.Root(guid))),
		{ enabled: guid !== undefined, retry: false }
	);
}
